import COURSE_CODES from './faculty_subjects.json';

export default COURSE_CODES;
